export default {
    namespaced: true,
    state: {
        category: null,
        course: null,
        ecp: null,
        convention: null,
        program: null,
        rate: null,
        mp_tot: null,
        installments: null,
        installments_next: null,
        singles: null,
        aa: null,
        recap: null,
        enrol_year: null,
        label: null,
        form: null,
        promo_code: null
    },
    mutations: {
        'SET_CATEGORY' (state, category) {
            state.category = category
        },
        'SET_COURSE' (state, course) {
            state.course = course
        },
        'SET_ECP' (state, ecp) {
            state.ecp = ecp
        },
        'SET_CONVENTION' (state, convention) {
            state.convention = convention
        },
        'SET_PROGRAM' (state, program) {
            state.program = program
        },
        'SET_RATE' (state, rate) {
            state.rate = rate
        },
        'SET_IMPORT' (state, mp_tot) {
            state.mp_tot = mp_tot
        },
        'SET_INSTALLMENTS' (state, installments) {
            state.installments = installments
        },
        'SET_SINGLES' (state, singles) {
            state.singles = singles
        },
        'SET_INSTALLMENTS_NEXT' (state, installments_next) {
            state.installments_next = installments_next
        },
        'SET_AA' (state, aa) {
            state.aa = aa
        },
        'SET_RECAP' (state, recap) {
            state.recap = recap
        },
        'SET_ENROL_YEAR' (state, year) {
            state.enrol_year = year
        },
        'SET_LABEL' (state, label) {
            state.label = label
        },
        'SET_FORM' (state, form) {
            state.form = form
        },
        'SET_PROMO_CODE' (state, promo_code) {
            state.promo_code = promo_code
        }
    },
    actions: {
        setCategory({ commit }, category) {
            commit('SET_CATEGORY', category)
        },
        setCourse({ commit }, course) {
            commit('SET_COURSE', course)
        },
        setEcp({ commit }, ecp) {
            commit('SET_ECP', ecp)
        },
        setConvention({ commit }, convention) {
            commit('SET_CONVENTION', convention)
        },
        setProgram({ commit }, program) {
            commit('SET_PROGRAM', program)
        },
        setRate({ commit}, rate) {
            commit('SET_RATE', rate)
        },
        setImport({ commit }, mp_tot) {
            commit('SET_IMPORT', mp_tot)
        },
        setInstallments({ commit }, installments) {
            commit('SET_INSTALLMENTS', installments)
        }, 
        setInstallmentsNext({ commit }, installments_next) {
            commit('SET_INSTALLMENTS_NEXT', installments_next)
        }, 
        setSingles({ commit }, singles) {
            commit('SET_SINGLES', singles)
        },
        setAA({ commit }, aa) {
            commit('SET_AA', aa)
        },
        setRecap({ commit }, recap) {
            commit('SET_RECAP', recap)
        },
        setEnrolYear({ commit }, year) {
            commit('SET_ENROL_YEAR', year)
        },
        setLabel({ commit }, label) {
            commit('SET_LABEL', label)
        },
        setForm ({ commit }, form) {
            commit('SET_FORM', form)
        },
        setPromoCode({ commit }, promo_code) {
            commit('SET_PROMO_CODE', promo_code)
        }
    },
    getters: {
        category: state => state.category,
        course: state => state.course,
        ecp: state => state.ecp,
        convention: state => state.convention,
        program: state => state.program,
        rate: state => state.rate,
        mp_tot: state => state.mp_tot,
        installments: state => state.installments,
        installments_next: state => state.installments_next,
        singles: state => state.singles,
        aa: state => state.aa,
        recap: state => state.recap,
        enrol_year: state => state.enrol_year,
        label: state => state.label,
        form: state => state.form,
        promo_code: state => state.promo_code
    }
}